import { defineMessages } from "react-intl";

const messages = defineMessages({
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    accuracy: {
        id: "tasks.rhyt.accuracy",
    },
    easy: {
        id: "tasks.rhyt.accuracy.easy",
    },
    normal: {
        id: "tasks.rhyt.accuracy.normal",
    },
    hard: {
        id: "tasks.rhyt.accuracy.hard",
    },
});

export default messages;
